module.exports = __webpack_public_path__ + "img/8.1b52b8aa.png";